import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function heroHomeAnimations() {
  const hero = document.querySelector(".hero-home");
  if (!hero) return;

  // ====== TESTO ======
  const heroTitle = hero.querySelector(".hero-home__title h1");
  const heroSubtitle = hero.querySelector(".hero-home__subtitle p");
  if (!heroTitle) return;

  gsap.set(heroTitle, { autoAlpha: 0, y: 60 });
  if (heroSubtitle) gsap.set(heroSubtitle, { autoAlpha: 0, y: 40 });

  gsap.to(heroTitle, {
    autoAlpha: 1,
    y: 0,
    duration: 1.2,
    ease: "power2.out",
    overwrite: "auto",
    scrollTrigger: { trigger: hero, start: "top 80%", once: true }
  });

  if (heroSubtitle) {
    gsap.to(heroSubtitle, {
      autoAlpha: 1,
      y: 0,
      duration: 1.0,
      ease: "power2.out",
      delay: 0.15,
      overwrite: "auto",
      scrollTrigger: { trigger: hero, start: "top 80%", once: true }
    });
  }

  // ====== ZOOM BACKGROUND SLIDES (1 -> 1.06 in 2.5s, poi resta) ======
  const swiperEl = hero.querySelector(".hero-home__bg .swiper");
  if (!swiperEl) return;

  const START_SCALE = 1.0;   // parte a grandezza reale
  const END_SCALE   = 1.06;  // zoom finale
  const DURATION    = 5;   // durata zoom
  const EASE        = "none";

  const tlMap = new WeakMap();

  const killTL = (slide) => {
    const tl = tlMap.get(slide);
    if (tl) tl.kill();
  };

  const setScale = (slide, scale) => {
    const img = slide?.querySelector(".hero-home__bg-img");
    if (img) gsap.set(img, { scale });
  };

  const animateToZoom = (slide) => {
    const img = slide?.querySelector(".hero-home__bg-img");
    if (!img) return;
    // da 1 a 1.06, poi resta lì (nessun reverse)
    const tl = gsap.fromTo(img, { scale: START_SCALE }, { scale: END_SCALE, duration: DURATION, ease: EASE });
    tlMap.set(slide, tl);
  };

  const attachWhenReady = () => {
    const swiper = swiperEl.swiper;
    if (!swiper) { requestAnimationFrame(attachWhenReady); return; }

    // init: porta tutte le slide a START, poi anima la attiva verso END
    swiper.slides.forEach((s) => { killTL(s); setScale(s, START_SCALE); });
    animateToZoom(swiper.slides[swiper.activeIndex]);

    // all'inizio del cambio: prepara la nuova attiva a START e kill eventuali TL
    swiper.on("slideChangeTransitionStart", () => {
      const next = swiper.slides[swiper.activeIndex];
      killTL(next);
      setScale(next, START_SCALE);
      // la precedente resta zoommata (END), verrà riportata a START quando tornerà attiva in futuro
    });

    // a fine transizione: lancia lo zoom sulla nuova attiva
    swiper.on("slideChangeTransitionEnd", () => {
      animateToZoom(swiper.slides[swiper.activeIndex]);
    });

    swiper.on("destroy", () => {
      swiper.slides.forEach((s) => { killTL(s); });
    });
  };

  attachWhenReady();
}